import React, { useEffect } from 'react';
import { useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { fetchSentComments } from "src/actions/community/commentsActions";
import { queryParams } from "src/helpers/UrlHelpers";

import Pagination from "src/componets/Pagination";
import Card from "src/componets/Card";
import CommentsList from "src/pages/community/Comments/_partials/_List";

const LIMIT = 20;

const _SentComments = ({ userId }: { userId: number | undefined }) => {
  const dispatch        = useAppDispatch();
  const [searchParams]  = useSearchParams();
  const currentPage     = queryParams.getInt(searchParams,'page') || 1;
  const count           = useAppSelector(state => state.community.comments.count);

  useEffect(() => {
    if (!userId) {
      return;
    }

    const params: any = {
      limit: LIMIT,
      offset: (currentPage - 1) * LIMIT
    };

    dispatch(fetchSentComments({ userId, params }))
  }, [userId, currentPage, dispatch]);

  return (
    <Card>
      <h4 className='v-content-title'>Comments</h4>
      <CommentsList />

      <Pagination total={count} size={LIMIT} />
    </Card>
  )
}

export default _SentComments;
